<template>
  <section class="video-widget" aria-label="Video player" :style="widgetStyle">
    <p v-if="header" ref="meta" class="video-widget__meta">
      <span>Now playing</span>
      <template v-if="header.category">
        <span aria-hidden="true">·</span>
        <span
          class="video-widget__category"
          :class="categoryTone && `video-widget__category--${categoryTone}`"
          >{{ header.category }}</span
        >
      </template>
      <template v-if="header.date">
        <span aria-hidden="true">·</span>
        <span class="video-widget__date">{{ header.date }}</span>
      </template>
    </p>
    <div v-if="activeVideo" class="video-widget__player" :style="playerStyle">
      <video-view :key="selectionKey" v-bind="activeVideo" :tracking-context="trackingContext" />
    </div>
    <p v-else class="video-widget__unavailable" role="status">Video unavailable</p>
    <h2 v-if="header?.title" ref="heading" class="video-widget__heading">{{ header.title }}</h2>
    <div v-if="videos.length > 1" class="video-widget__carousel" :style="rowStyle">
      <swiper
        :slides-per-view="slidesPerView"
        :space-between="layout.spaceBetween"
        :modules="swiperModules"
        :watch-overflow="true"
        :resize-observer="true"
        :nested="true"
        :a11y="{ enabled: true }"
        @swiper="onSwiper"
        @slideChange="updateNavigation"
        @resize="updateNavigation"
        @lock="updateNavigation"
        @unlock="updateNavigation"
      >
        <swiper-slide v-for="(video, index) in videos" :key="video.videoUUID || index">
          <button
            type="button"
            class="video-widget__card"
            :class="{ 'video-widget__card--active': index === selectedIndex }"
            :aria-pressed="index === selectedIndex"
            :aria-label="titleFor(video) ? `Select video: ${titleFor(video)}` : 'Select video'"
            :title="titleFor(video) || undefined"
            @click="selectVideo(index)"
            @focus="revealCard(index)"
          >
            <img
              v-if="thumbnailFor(video)"
              :src="thumbnailFor(video)"
              :alt="titleFor(video)"
              loading="lazy"
              @error="imageFailed(video)"
            />
            <span class="video-widget__play" aria-hidden="true">▶</span>
            <span v-if="titleFor(video)" class="video-widget__title">{{ titleFor(video) }}</span>
          </button>
        </swiper-slide>
      </swiper>
      <template v-if="videos.length > slidesPerView">
        <button
          type="button"
          class="video-widget__arrow video-widget__arrow--previous"
          aria-label="Previous videos"
          :disabled="!canPrevious"
          @click="swiper?.slidePrev()"
        >
          ‹
        </button>
        <button
          type="button"
          class="video-widget__arrow video-widget__arrow--next"
          aria-label="Next videos"
          :disabled="!canNext"
          @click="swiper?.slideNext()"
        >
          ›
        </button>
      </template>
    </div>
  </section>
</template>
<script src="./video-widget.js"></script>
<style src="./video-widget.scss" lang="scss"></style>
